export default __webpack_public_path__ + "static/media/logo.9aca5e83.png";